import Lakmeacademy from "../assets/images/portfolio/lakme-academy.png";
import Oceangreen from "../assets/images/portfolio/oceangreen.png";
import Brandanimators from "../assets/images/portfolio/brandanimators.png";
import Softmarksolutions from "../assets/images/portfolio/softmarksolutions.png";
import Careboxhealthcare from "../assets/images/portfolio/careboxhealthcare.png";
import Innerfocusbytam from "../assets/images/portfolio/innerfocusbytam.png";
import Trypuremoringa from "../assets/images/portfolio/trypuremoringa.png";
import Kuvingsisrael from "../assets/images/portfolio/kuvings-israel.png";
import Funkeschlusseldienst from "../assets/images/portfolio/funke-schlusseldienst.png";
import Probit from "../assets/images/portfolio/pro-bit.png";
import Villagetalkies from "../assets/images/portfolio/villagetalkies.png";
import Rajumagi from "../assets/images/portfolio/rajumagi.png";
import Natarajnilastore from "../assets/images/portfolio/natarajnilastore.png";
import Zzztape from "../assets/images/portfolio/zzztape.png";
import Travoka from "../assets/images/portfolio/travoka.png";
import Trustedlabsmd from "../assets/images/portfolio/trustedlabsmd.png";
import Zunotrix from "../assets/images/portfolio/zunotrix.png";
import Hotdealsbazaar from "../assets/images/portfolio/hotdealsbazaar.png";
import Bimand from "../assets/images/portfolio/bimand.png";
import Xtecpro from "../assets/images/portfolio/xtecpro.png";
import Kxarquitectura from "../assets/images/portfolio/kxarquitectura.png";
import Hakamtcs from "../assets/images/portfolio/hakamtcs.png";
import Paisavasooldeals from "../assets/images/portfolio/paisavasooldeals.png";
import Seoengine from "../assets/images/portfolio/seoengine.png";
import Travelblog from "../assets/images/portfolio/travelblog.png";
import Instaengagement from "../assets/images/portfolio/insta-engagement.png";
import Sapelectrical from "../assets/images/portfolio/sapelectrical.png";
import Drmachinery from "../assets/images/portfolio/drmachinery.png";
import Topusenet from "../assets/images/portfolio/topusenet.png";
import Highproxies from "../assets/images/portfolio/highproxies.png";
import Sanhebeauty from "../assets/images/portfolio/sanhebeauty.png";
import Wptopspeed from "../assets/images/portfolio/wptopspeed.png";
import Changfatextile from "../assets/images/portfolio/changfatextile.png";
import Vitaboosterpro from "../assets/images/portfolio/vitaboosterpro.png";
import Shopbiogrowrx from "../assets/images/portfolio/shopbiogrowrx.png";
import Psgrand from "../assets/images/portfolio/psgrand.png";
import Padelot from "../assets/images/portfolio/padelot.png";
import Slotsonline from "../assets/images/portfolio/slots-online.png";
import Everpure from "../assets/images/portfolio/everpure.png";
import Poppyshotels from "../assets/images/portfolio/poppyshotels.png";

let WorkData = [
  {
    id: 1,
    projectName: "Lakme academy",
    projectDetails:
      "Lakmē Academy powered by Aptech is a leading beauty training institute in India offering professional courses in cosmetology, makeup, hair, and skincare to help you build a successful career in the beauty industry.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "NextJS"],
    imageURL: Lakmeacademy,
  },
  {
    id: 1,
    projectName: "Poppyshotels",
    projectDetails:
      "The flagship Company of the Group, managing and operating a chain of Hotels in Tamil Nadu and Kerala. It has the distinction of being one of fastest growing chains in the sector. With a presence across the South in destinations like Madurai, Rameswaram, Kumbakonam, Ooty, kodaikanal, Pondicherry in Tamil Nadu and Anaikatti in Kerala, the Company has visionary plans across more destinations across the Country.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "NextJS"],
    imageURL: Poppyshotels,
  },

  {
    id: 2,
    projectName: "Padelot",
    projectDetails:
      "Padelot is an online padel shop offering a catalog with the best selection of rackets, clothing, shoes, racket bags, accessories, and much more. All the equipment you need to make your experience on the padel court the best it can be. Find top quality in all the products in our store. We have the best selection of padel brands, from Drop Shot, Akkeron, Ares, and Star Vie, to renowned companies like Adidas, Bullpadel, Babolat, and many more.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Woocommerce"],
    imageURL: Padelot,
  },
  {
    id: 2,
    projectName: "Ocean Green",
    projectDetails:
      "At Ocean Green, we’re diving into a sea of creativity and fun! Founded by a quirky crew who loves all things whimsical and vibrant, we set out to create a brand that reflects our personalities—colorful, playful, and a bit unpredictable!",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Woocommerce"],
    imageURL: Oceangreen,
  },
  {
    id: 2,
    projectName: "Everpure",
    projectDetails:
      "Everpure's journey began with a single creation - an onion and amla herbal hair oil. Meticulously researched and crafted by Shahla to address her daughters' hair fall concerns, this formulation proved to be remarkably effective. As word spread, neighbors began seeking this natural remedy for their own hair and scalp issues. The overwhelming positive feedback and repeat requests became the catalyst for Everpure's birth.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Shopify"],
    imageURL: Everpure,
  },

  {
    id: 3,
    projectName: "Slots online",
    projectDetails:
      "Behind slots-online.es is a large team made up of experienced players in the world of slots and online casinos. For years, we have gathered experience and knowledge about the different operators in the Spanish market. We also know that the selection is vast. That's why we decided to create this guide with everything you need to know to become an expert player.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Wordpress"],
    imageURL: Slotsonline,
  },
  {
    id: 3,
    projectName: "Brand animators",
    projectDetails:
      "Best 2D/3D animated explainer video production company in Houston, Dallas, TX &amp; San Francisco, California, USA offers explainer videos, corporate videos, 3d product animation videos, 3d medical animation videos, 3d architectural walkthrough animation, product demo videos, app explainer videos, e-Learning videos, Motion Graphics, whiteboard videos, character animation videos, employee training videos, marketing videos and more.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Elementor"],
    imageURL: Brandanimators,
  },
  {
    id: 4,
    projectName: "Softmark solutions",
    projectDetails:
      "With SEO, Google Ads, tracking and Google My Business, we bring your company to the forefront online – for measurable success and more customers",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Elementor"],
    imageURL: Softmarksolutions,
  },

  {
    id: 5,
    projectName: "Carebox healthcare",
    projectDetails:
      "A progressive firm driven to provide pioneering healthcare solutions to enhance the patient experience with a wide range of services designed to streamline healthcare operations and a focus on efficiency, accessibility, and patient-centered care.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Elementor"],
    imageURL: Careboxhealthcare,
  },

  {
    id: 6,
    projectName: "Inner focus by tam",
    projectDetails: "Mental Health First Aid Training & Wellbeing Workshops",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Elementor"],
    imageURL: Innerfocusbytam,
  },

  {
    id: 7,
    projectName: "Trypuremoringa",
    projectDetails:
      "Pure Moringa supports mental clarity, boosts energy, and holistically heals your body - making tough mornings a thing of the past.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Shopify"],
    imageURL: Trypuremoringa,
  },

  // {
  //   id: 8,
  //   projectName: "Kuvings israel",
  //   projectDetails:
  //     "Kuvings – the choice of health lovers in over 90 countries around the world. A leading brand for smart kitchen products, designed to make healthy living more efficient, convenient and delicious. At Kuvings, we strive to develop the highest quality products – so you can enjoy wellness at every stage of your day.",
  //   projectTechnologies: ["HTML", "CSS", "JavaScript", "Shopify"],
  //   imageURL: Kuvingsisrael,
  // },

  {
    id: 9,
    projectName: "Funke schlusseldienst",
    projectDetails:
      "Reliable locksmith service in Berlin – fast & trustworthy! Fast, reliable locksmith service in Berlin – available 24 hours a day! Fair prices, professional assistance, and maximum security.",
    projectTechnologies: ["HTML", "CSS", "Fusion Builder"],
    imageURL: Funkeschlusseldienst,
  },

  // {
  //   id: 10,
  //   projectName: "Probit",
  //   projectDetails:
  //     "We specialize in training top-notch agents and agencies, and in managing insurance portfolios and financial planning for both individuals and businesses.",
  //   projectTechnologies: ["HTML", "CSS", "JavaScript", "Elementor"],
  //   imageURL: Probit,
  // },

  {
    id: 11,
    projectName: "Villagetalkies",
    projectDetails:
      "Village Talkies is the top corporate video production company and best animated explainer video production company in Dubai, UAE. Renowned as one of the best 2D/3D animation studio in Dubai, UAE specialized in creating high-quality 3d animation videos, 2d animation videos, corporate videos, brand films, training videos, safety videos, animated explainer videos  etc. delivering budget-friendly solutions without compromising on quality. Village Talkies is your go-to partner for all your video production needs in Dubai, UAE.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Elementor"],
    imageURL: Villagetalkies,
  },

  {
    id: 12,
    projectName: "Rajumagi",
    projectDetails:
      "At Rajumagi, we’re diving into a sea of creativity and fun! Founded by a quirky crew who loves all things whimsical and vibrant, we set out to create a brand that reflects our personalities—colorful, playful, and a bit unpredictable!",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Woocommerce"],
    imageURL: Rajumagi,
  },

  {
    id: 13,
    projectName: "Nataraj nila store",
    projectDetails:
      "At natarajnilastore.in, we’re diving into a sea of creativity and fun! Founded by a quirky crew who loves all things whimsical and vibrant, we set out to create a brand that reflects our personalities—colorful, playful, and a bit unpredictable!",
    projectTechnologies: ["HTML", "CSS", "Wordpress", "Woocommerce"],
    imageURL: Natarajnilastore,
  },

  {
    id: 14,
    projectName: "ZZZtape",
    projectDetails:
      "Experience the Life-Changing Benefits of Nose Breathing with the Ideal Mouth Tape & Nasal Strips.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Shopify"],
    imageURL: Zzztape,
  },

  {
    id: 15,
    projectName: "Travoka",
    projectDetails: "Unlock the Wonders of the World With Travoka Travels",
    projectTechnologies: ["HTML", "CSS", "Beaver Builder"],
    imageURL: Travoka,
  },

  {
    id: 16,
    projectName: "Vitaboosterpro",
    projectDetails:
      "Eating Healthy Is Crucial For Overall Well-Being As It Provides Essential Nutrients That Support Bodily Functions, Boost The Immune System, And Maintain A Healthy Weight. A Balanced Diet Rich In Fruits, Vegetables, Whole Grains, And Lean Proteins Can Improve Overall Wellbeing.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Shopify"],
    imageURL: Vitaboosterpro,
  },

  {
    id: 17,
    projectName: "Shopbiogrowrx",
    projectDetails:
      "Unlock Luscious Locks And Promote Hair Growth With Our Advanced Hair Growth Supplement. Experience The Ultimate In Hair Health And Vitality.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Shopify"],
    imageURL: Shopbiogrowrx,
  },

  {
    id: 18,
    projectName: "Psgrand",
    projectDetails:
      "No matter what type of work you do, PS Grand has the most jobs, the best tools, and expert advice to help you get cast.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Shopify"],
    imageURL: Psgrand,
  },
  {
    id: 19,
    projectName: "Trustedlabsmd",
    projectDetails:
      "Trusted Labs MD provides high-quality, all-natural supplements at affordable prices. We put your health first and foremost. At Trusted Labs all of our ingredients are lab tested & quality is guaranteed. Our team works to bring you the safest, most effective options to help you become a healthier you.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Shopify"],
    imageURL: Trustedlabsmd,
  },

  {
    id: 20,
    projectName: "Hotdealsbazaar",
    projectDetails:
      "Affiliate marketing presents an exciting opportunity for individuals to generate passive income without the complexities of product creation or inventory management. Affiliates can leverage a diverse selection of products or services, choosing those aligning with their audience. This flexibility extends to promotional methods, empowering affiliates to utilize blogs, social media, or email marketing. With low financial risk and performance-based earnings, affiliates earn commissions for each sale they drive.",
    projectTechnologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "ReactJS",
      "ExpressJS",
      "Strapi",
    ],
    imageURL: Hotdealsbazaar,
  },

  {
    id: 21,
    projectName: "Zunotrix",
    projectDetails:
      "Currently I am a front-end developer and my goal is to become MERN stack developer. I created my portfolio website which contains all my details. Other people can see about me, my skills, projects I have done and can also send me a message. I will use this website for professional development to get hired in a best software company and also to get freelancing projects. I will always update it gradually.",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Elementor"],
    imageURL: Zunotrix,
  },

  {
    id: 22,
    projectName: "Bimand",
    projectDetails:
      "BIMAND's main objective is to introduce everything that the BIM methodology entails in the Principality of Andorra, offering advice , training and service provision . Our team has more than 8 years of experience working in BIM methodology. During all this time we have not stopped training , obtaining postgraduate degrees and professional certifications , among which the BIM Masters and the Revit ACP stand out . At a professional level, we have developed more than 40 architecture, structure and installation projects; we have provided training to more than 50 professionals in the AEC sector and; we have offered services such as implementations , energy analyzes and BIM models .",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    imageURL: Bimand,
  },

  {
    id: 23,
    projectName: "Xtecpro",
    projectDetails:
      "XTecPro is a service-oriented Information Technology organization that provides solutions and support of Enterprise Business Applications and B2B-EDI to Customer's need and requirements. We also engage ourselves in providing database support for various business applications",
    projectTechnologies: ["HTML", "CSS", "PHP", "jQuery", "Bootstrap"],
    imageURL: Xtecpro,
  },

  {
    id: 24,
    projectName: "Kxarquitectura",
    projectDetails:
      "Architecture studio that merge design expertise and new technologies to achieve your goals",
    projectTechnologies: ["HTML", "CSS", "jQuery"],
    imageURL: Kxarquitectura,
  },

  {
    id: 25,
    projectName: "Hakamtcs",
    projectDetails:
      "We are provider and Supplier of longer shelf life and supreme quality cocunut in Qatar, which procured from different farm in pollachi india, our products are in huge demand amongst our clients due to their worthier equality, we provide facility to our customers to customise of packing.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Hakamtcs,
  },

  {
    id: 26,
    projectName: "Paisavasooldeals",
    projectDetails:
      "Welcome to paisavasooldeals.com, your number one source for all things Discounts,Best Deals.We're dedicated to provide you the very best of products through our third party sites at a very minimal price, with a focus on Originality, customer service and uniqueness",
    projectTechnologies: ["HTML", "CSS", "JavaScript", "Wordpress"],
    imageURL: Paisavasooldeals,
  },

  {
    id: 27,
    projectName: "Insta Engagement",
    projectDetails:
      "Insta-Engagement is owned and operated by Review & Views a digital consulting firm. Insta-Engagement is an organic Instagram engagement and growth service that brings you the growth techniques to successfully grow any Instagram account.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Instaengagement,
  },

  {
    id: 28,
    projectName: "Sap electrical",
    projectDetails:
      "SAP Electrical are experienced LV & HV cable jointing contractors providing a range of cable jointing solutions.",
    projectTechnologies: ["HTML", "CSS", "Wordpress", "jQuery"],
    imageURL: Sapelectrical,
  },

  {
    id: 29,
    projectName: "Seoengine",
    projectDetails:
      "SEO stands for search engine optimization. It is the process of getting traffic from the free, organic, editorial or natural search results on search engines.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Seoengine,
  },

  {
    id: 30,
    projectName: "Travel Blog",
    projectDetails:
      "A captivating travel blog entices readers with vivid storytelling, transporting them to exotic destinations. Engaging narratives, complemented by stunning visuals, create a sensory experience. Practical tips and itineraries aid fellow travelers, while personal anecdotes add authenticity. Insightful cultural observations and local cuisine highlights provide a well-rounded perspective. Incorporating a touch of humor or unique insights adds flair. ",
    projectTechnologies: ["HTML", "CSS", "PHP"],
    imageURL: Travelblog,
  },

  {
    id: 31,
    projectName: "D&R Machinery",
    projectDetails:
      "D&R Machinery are professional confectionery machine manufacturers with over 15 years in the business operating at the highest industry standards. We’ve built a reputation on engineering, designing and delivering high performance total-solution confectionery machinery to clients with absolute precision around the world.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Drmachinery,
  },

  {
    id: 32,
    projectName: "Topusenet",
    projectDetails:
      "Files and messages are stored on our own servers, making it possible to download at top speed. The download speed depends on your own internet quality and that of the Usenet provider. At Usenet.nl , for example, you can download at up to 800 MBit/s.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Topusenet,
  },

  {
    id: 33,
    projectName: "Highproxies",
    projectDetails:
      "Our Social Media proxies are one of the best that you can find. Premium private proxies, fast, reliable and cheap. Your  problems will be over once you start using our Social Media proxies. Our proxies are specifically tested to be used on social media platforms. Our proxy server fleet is maintained and monitored by a professional team of system administrators around the clock, guarding the stable and fast operation of the proxy.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Highproxies,
  },

  {
    id: 34,
    projectName: "Sanhe Beauty",
    projectDetails:
      "Sanhe has built an excellent, world-wide beauty industry reputation not just for OEM/ODM manufacturing of top-value beauty and health equipment, but for comprehensive solutions. We beat most competition for price and features, and match top-tier suppliers through great visual design of the machines themselves. We best all comers, however, with excellent guarantees, clear and sincere communication, and localized service.",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Sanhebeauty,
  },

  {
    id: 35,
    projectName: "Wptopspeed",
    projectDetails:
      "We have developed all kind of websites and since the last updates from Google algorithms we decided to focus solely improving the performance of our clients, helping them increase both conversions and rankings (since it's now a very important ranking factor).",
    projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
    imageURL: Wptopspeed,
  },

  // {
  //   id: 36,
  //   projectName: "Changfatextile",
  //   projectDetails:
  //     "Clients throughout the Americas, Europe, and Asia know CHANGFA as the fabric sector’s top choice for high-end digital printing of polyester, cotton, rayon, and silk featuring stylish, vivid, 3-D flower-based designs. Why? Firstly, integrity. As a long-running family founded and owned company, our promise to you is a promise kept whether it be product quality, delivery date, or service level. ",
  //   projectTechnologies: ["HTML", "CSS", "jQuery", "Wordpress"],
  //   imageURL: Changfatextile,
  // },
];

export default WorkData;
